import { useState, useEffect, useContext, useMemo } from 'react'
import URLstateContext from "../../provider/CommonContext";
import calendermf from '../../../src/images/calendermf.png';
import exelthis from '../../../src/images/exelthis.png';
import { DecryptAESdata, GetPostMethodData } from '../../provider/ServiceProvider';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
// import Pagination from 'rc-pagination';
import { Pagination } from 'antd';
import animation from '../../images/jm-animation.gif';
import execl from '../../images/excel.png'
import * as XLSX from 'xlsx';
import './TERRatio.css';
function TERRatio() {
    const dayjs = require('dayjs');
    const currentDate = dayjs();
    const lastMonthDate = currentDate.subtract(1, 'day').subtract(1, 'month');
    const lastMonthDateFormatted = lastMonthDate.format('YYYY-MM-DD');
    const [DataMisc, setDataMisc] = useState("");
    const { BaseURL, BaseURLShare } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    const [data, setData] = useState("");
    const [current, setCurrent] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [size, setSize] = useState(perPage);
    const [valuedate, setValuedate] = useState(dayjs());
    const [StartDate, setStartDate] = useState(dayjs(lastMonthDateFormatted))
    const [valuedatelatest, setValuedateLatest] = useState('');
    const [endDate, setlastDate] = useState('');
    let PageSize = size;
    const handleChangedate = (StartDatenew) => {
        const datestart = dayjs(StartDatenew).format('YYYY-MM-DD');
        setValuedateLatest(datestart);
        // alert(datestart, "datestart")
    }

    const isDateInFuture = (date) => {
        return dayjs(date).isAfter(dayjs(), 'day');
    };
    const handleChangedateEnd = (newValue) => {
        const val = dayjs(newValue).format('YYYY-MM-DD');
        setlastDate(val)
    }


    useEffect(() => {
        window.scroll(0, 0)
        const dateString = dayjs(valuedate).format('YYYY-MM-DD');
        const dateStringLast = dayjs(StartDate).format('YYYY-MM-DD');
        // setTimeout(() => {
        setloadingshow(true);
        GetPostMethodData(BaseURL + "GetTER", {
            "IDStartdate": dateStringLast,
            "IDEnddate": dateString

        }).then((data) => {

            if (data.data != null && data.data.length > 0) {
                setData(DecryptAESdata(data.data));
                setloadingshow(false);
                setCurrent(1);
            }
            else {
                setData('');
                setloadingshow(false);
            }
        });
        // }, 1000);

    }, [BaseURL]);

    function exportToExcel(data) {
        // const dataNew = data.map(item => {
        //     const dataItem = {};
        //     columns.forEach(column => {
        //         dataItem[column.label] = item[column.value];
        //     });
        //     return dataItem;
        // });
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(data);
        const columnWidths = [
            { wch: 14 },
            { wch: 48 },
            { wch: 14 },
            { wch: 13 },
            { wch: 12 }
        ];
        worksheet['!cols'] = columnWidths;
        const cellNumberFormat = '#,##0.00';
        const cell = XLSX.utils.encode_cell({ r: 0, c: 0 });
        worksheet[cell].z = cellNumberFormat;
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Expanse Ratio');
        XLSX.writeFile(workbook, 'Expanse Ratio.xlsx');
    }

    const PaginationChange = (page, pageSize) => {
        setCurrent(page);
        setSize(pageSize);
    }
    const currentTableData = useMemo(() => {
        if (data != null) {
            // const firstPageIndex = (current - 1) * PageSize;
            // const lastPageIndex = firstPageIndex + PageSize;
            if (data != null) {
                if (data.length > 0) {
                    // return data.slice(firstPageIndex, lastPageIndex);
                    return data.slice((current - 1) * PageSize, current * PageSize);

                }
            }
        }
    }, [current, data, PageSize]);

    const showTotal = (total, range) => `Showing ${range[0]}-${range[1]} of ${total}`;

    const PrevNextArrow = (current, type, originalElement) => {
        if (type === 'prev') {
            return <button aria-label='previous arrow'><i className="fa fa-angle-double-left"></i></button>;
        }
        if (type === 'next') {
            return <button aria-label='next arrow'><i className="fa fa-angle-double-right"></i></button>;
        }
        return originalElement;
    }

    const buttonGo = () => {
        const dateString = dayjs(valuedate).format('YYYY-MM-DD');
        const dateStringLast = dayjs(StartDate).format('YYYY-MM-DD');


        const apiParams = {

        };

        if (valuedatelatest !== '' && endDate !== '') {
            apiParams.IDstartdate = valuedatelatest;
            apiParams.IDenddate = endDate;
        }
        else if (valuedatelatest !== '' && endDate === '') {
            apiParams.IDstartdate = valuedatelatest;
            apiParams.IDenddate = dateString;
        }
        else if (valuedatelatest === '' && endDate !== '') {
            apiParams.IDstartdate = dateStringLast;;
            apiParams.IDenddate = endDate;
        }
        else {
            apiParams.IDstartdate = dateStringLast;
            apiParams.IDenddate = dateString;
        }

        GetPostMethodData(BaseURL + "GetTER", apiParams).then((data) => {
            if (data.data != null && data.data.length > 0) {
                setData(DecryptAESdata(data.data));
                // console.log(data.data)
                setCurrent(1);
            }
        });
        // }
    };
    return (
        <>
            <div class="terjmmf-main">
                <section class="termfone">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12 col-md-12">
                                <h2>TOTAL EXPENSE RATIO (TER)</h2>
                                <h6>Check the upcoming TER change of DSP Mutual Fund Schemes. Click the below link for notices.
                                </h6>
                                <button aria-label='notice foe TER change'><a>Notice for TER Change</a></button>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="termftwo">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12 col-md-12">
                                <div class="datecalendergrid">
                                    {/* <div class="poserela">
                                        <input type="text" name="" id="" placeholder="From Date" />
                                        <img class="calendericon" src={calendermf} alt="calendermf" />
                                    </div>
                                    <div class="poserela">
                                        <input type="text" name="" id="" placeholder="To Date" />
                                        <img class="calendericon" src={calendermf} alt="calendermf" />
                                    </div> */}

                                    <div className="cale-Ter" id="datedrop">
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={['DatePicker', 'DatePicker']}>
                                                <DatePicker
                                                    label="Start Date"
                                                    value={StartDate}
                                                    disableFuture // Disable future dates
                                                    format="DD/MMM/YYYY"
                                                    onChange={(StartDatenew) => handleChangedate(StartDatenew)}
                                                    inputProps={{ placeholder: 'Select Date' }} // Add placeholder
                                                />
                                                <DatePicker
                                                    label="End Date"
                                                    value={valuedate}
                                                    disableFuture // Disable future dates
                                                    format="DD/MMM/YYYY"
                                                    onChange={(newValue) => handleChangedateEnd(newValue)}
                                                    inputProps={{ placeholder: 'Select Date' }} // Add placeholder
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                    </div>

                                    <button onClick={buttonGo} aria-label='view TER'>View TER</button>
                                </div>
                                <div class="fileandtext">
                                    <div>
                                        {/* <span>Displaying 20 of 105 results</span> */}
                                        {currentTableData != null ?
                                            <div>

                                                {showTotal(data.length, [1, currentTableData.length])}

                                            </div>
                                            :
                                            ''
                                        }
                                    </div>
                                    <div>
                                        <span>Export As{" "}</span>
                                        <img src={execl} onClick={() => exportToExcel(data)} className='cursorpointer' alt='ExportToExcel'></img>

                                        {/* {DataMisc && DataMisc.map(({ FileName, SubCategoryName }, index) => (

                                            < img key={index} src={exelthis} onClick={() => window.open(BaseURLShare + FileName, "_blank")} target="blank" alt="exelthis" />
                                        ))} */}
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </section>


                <section class="termfthree">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12 col-md-12">
                                <div class="table-responsive">
                                    <table className='tableone'>
                                        <thead>
                                            <tr class="trfirst">
                                                <th>Date</th>
                                                <th>Fund Name</th>
                                                <th colspan="5">Regular Plan</th>
                                                <th colspan="6">Direct Plan</th>
                                            </tr>
                                            <tr class="trseconds">
                                                <th></th>
                                                <th></th>
                                                <th >Base TER (%) 1</th>
                                                <th >Additional <br></br> expenses asper Regulation <br></br> 52(6A) <br></br> (b)(%)2
                                                </th>
                                                <th >Additional <br></br> expenses asper Regulation <br></br> 52(6A) <br></br> (b)(%)2
                                                </th>
                                                <th >GST (%) 4</th>
                                                <th >Total TER (5)</th>
                                                <th >Base TER (%) 1</th>
                                                <th>Additional <br></br> expenses asper Regulation <br></br> 52(6A) <br></br> (b)(%)2</th>
                                                <th>Additional <br></br> expenses asper Regulation <br></br> 52(6A) <br></br> (b)(%)2</th>
                                                <th >GST (%) 4</th>
                                                <th >Total TER (5)</th>
                                                <th ></th>
                                            </tr>


                                            {currentTableData && currentTableData.map(
                                                (
                                                    { TERDate, RegularBaseTER, RegularAddExpA, RegularAddExpB, RegularGST, RegularTotalTER,
                                                        DirectBaseTER, DirectAddExpA, DirectAddExpB, DirectGST, DirectTotalTER, FundName
                                                    },
                                                    index
                                                ) => (
                                                    <tr class="trthree">
                                                        <th>{TERDate != null ? TERDate : '-'}</th>
                                                        <th>{FundName}</th>
                                                        <th>{RegularBaseTER}</th>
                                                        <th>{RegularAddExpA != null ? RegularAddExpA : '-'}</th>
                                                        <th>{RegularAddExpB != null ? RegularAddExpB : '-'}</th>
                                                        <th>{RegularGST != null ? RegularGST : '-'}</th>
                                                        <th>{RegularTotalTER != null ? RegularTotalTER.toFixed(2) : '-'}</th>
                                                        <th>{DirectBaseTER != null ? DirectBaseTER : '-'}</th>
                                                        <th>{DirectAddExpA != null ? DirectAddExpA : '-'}</th>
                                                        <th>{DirectAddExpB != null ? DirectAddExpB : '-'}</th>
                                                        <th>{DirectGST != null ? DirectGST : '-'}</th>
                                                        <th>{DirectTotalTER != null ? DirectTotalTER : '-'}</th>

                                                    </tr>
                                                )
                                            )}
                                            {loadingshow ? <div className="textcentervertex">
                                                <img src={animation} alt="Loading" />
                                                <div className="model_popup">Please Wait...</div>
                                            </div> : ''

                                            }
                                        </thead>
                                    </table>
                                </div>

                                <div class="">
                                    {currentTableData && currentTableData.length > 0 && (
                                        <Pagination
                                        align='end'
                                            className="pagination-data"
                                            showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total}`}
                                            onChange={PaginationChange}
                                            total={data.length != null ? data.length : 0}
                                            current={current}
                                            pageSize={size}
                                            showTitle = {false}
                                            showSizeChanger={false}
                                            itemRender={PrevNextArrow}
                                        //onShowSizeChange={PerPageChange}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <section class="termffour">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="back">
                                    <ul>
                                        <h6>Note</h6>
                                        <ul>
                                            <li>1. Base TER excludes additional expenses provided in Regulation 52(6A)(b) and
                                                52(6A)(c) of SEBI (Mutual Funds) Regulations, 1996.</li>
                                            <li>2. Additional Expenses not exceeding 0.30% in terms of Regulation 52(6A)(b) of
                                                SEBI (Mutual Funds) Regulations, 1996.</li>
                                            <li>4. Present GST rate is 18 %.</li>
                                            <li>5. Percentages mentioned above are annualized.</li>
                                            <li>6. Base TER of direct plan shall have a lower expense ratio excluding
                                                distribution expenses, commission, etc., and no commission shall be paid from
                                                such plans.</li>
                                            <li>7. Expense Ratio of Unclaimed Plan is same as Expense Ratio of Direct Plan of
                                                DSP Overnight Fund and, as per SEBI circular SEBI/HO/IMD/IMD•II
                                                DOF3/P/ClR/2021/608 date <br></br>
                                                July 30, 2021 TER of unclaimed plan shall be capped as per the TER of direct
                                                plan in such scheme or at 50bps whichever is lower.
                                            </li>
                                            <li>8. 'N Expense Ratio disclosed is inclusive of the Total Expenses levied by
                                                underlying schemes under regulation 52(6)(a) of SEBI (Mutual Funds) Regulations,
                                            </li>
                                        </ul>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>









            </div>
            {/* <!-- Distibutors Code End --> */}



            {/* <script src="js/jquery.min.js"></script>
    <script src="js/popper.min.js"></script>
    <script src="js/bootstrap.min.js"></script>
    <script src="js/slick.js"></script> */}


            {/* <script>

        $('.slider').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 4.4,
            slidesToScroll: 1,
            prevArrow: ".slide-btn-left",
            nextArrow: ".slide-btn-right",
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1.8,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $("li.nav-item a.nav-link").click(function () {
            $(" li.nav-item a.nav-link").removeClass('active');
        });
    </script> */}



        </>
    )
}

export default TERRatio
